import { Auth } from 'aws-amplify';


export default {
  signIn: async ({ username, password }) => {
    const user = await Auth.signIn(username, password);
    return user
  },
  signOut: async () => {
    await Auth.signOut();
  },
  deleteUser: async () => {
    await Auth.deleteUser();
  },
  signUp: async (pl) => {
    const user = await Auth.signUp(pl);
    return user
  },
  forgotPassword: async ({ username }) => {
    const user = await Auth.forgotPassword(username);
    return user
  },
  resetPassword: async ({ username, code, password }) => {
    const user = await Auth.forgotPasswordSubmit(username, code, password);
    return user
  },
  completeNewPassword: async (user, password) => {
    const res = await Auth.completeNewPassword(user, password)
    return res;
  },
  federatedSignIn: async ({ config, provider }) => {
    const target = `https://${config.oauth.domain}/oauth2/authorize?identity_provider=${provider}&redirect_uri=${config.oauth.redirectSignIn}&response_type=${config.oauth.responseType}&client_id=${config.userPoolWebClientId}&scope=${config.oauth.scope.join(' ')}`
    window.location.replace(target)
  }
}